<template>

<div class="two-columns product-controls">
	<button class="button primary product-detail-link" href="#">Details</button>
	<button class="button action add-to-cart" href="#">Add to Cart</button>
</div>

</template>

<script>
export default {
	name: 'product-controls',
	props: ['product']
}
</script>
